import React from 'react';
import styles from './AttachmentsTray.module.scss';
import AttachmentChip from './AttachmentChip';

export default function AttachmentsTray({
  items = [],
  onRemove,

  mode = 'overlay',
  position = 'top',
  maxVisible = 6,
}) {
  if (!items.length) return null;

  const visible = items.slice(0, maxVisible);
  const rest = items.length - visible.length;

  return (
    <div className={styles.tray} data-mode={mode} data-position={position} role='group' aria-label='Attachments'>
      <div className={styles.row}>
        {visible.map((item) => (
          <AttachmentChip key={item.id} item={item} onRemove={onRemove} />
        ))}

        {rest > 0 ? <span className={styles.more}>+{rest}</span> : null}
      </div>
    </div>
  );
}
